import * as mutationType from "../mutation_types";

const state = {
  score: {}
};

const getters = {
  score: state => state.score
};

const actions = {
  getEngagement({ commit }, request) {
    commit(mutationType.SET_ENGAGEMENT, {});
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/engagement", request)
        .then(res => {
          commit(mutationType.SET_ENGAGEMENT, res.data);
          resolve(res.data);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_ENGAGEMENT](state, score) {
    state.score = score;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
